import { createSlice } from '@reduxjs/toolkit';


const xconfig = window.xconfig || {
    axios: {
        baseURL:'',
        backend:'',
        beta:false,
    },
    router:{
        routesBaseName: '/'
    }
};


const configSlice = createSlice({
    name: 'config',
    initialState: {
        axios: {
            baseURL:xconfig.axios.baseURL,
            backend:xconfig.axios.backend,
            beta:xconfig.axios.beta,
        },
        router:{
            routesBaseName: xconfig.router.routesBaseName
        },
        cookieconsent:"PanoViewer.CookiesAllowed",
        debugAxios:true,
        debugPing:false,
        development:true,
    },
    reducers: {
    },
});


const { reducer, actions } = configSlice;


// export const { showLoader, hideLoader } = actions;


export const config = (state) => {
    return state.config;
};


export default reducer;
